/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".validation-error[_ngcontent-%COMP%]{display:flex;height:40px;margin-top:-98px;text-transform:uppercase}.validation-error[_ngcontent-%COMP%]   .error-message[_ngcontent-%COMP%]{line-height:14px;width:calc(100% - 24px - 4px);text-overflow:ellipsis;font-size:12px;align-items:center;display:flex;margin-left:4px}"];
export { styles as styles };
